import { Component, inject, input, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { ColDef } from 'ag-grid-enterprise';
import { IconSanitizerService } from 'ngx-lib';
import { IGroupLevel } from '../group-by-rows-filter.component';

@Component({
    selector: 'app-column-selector',
    templateUrl: './column-selector.component.html',
    styleUrls: ['./column-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class ColumnSelectorComponent {
    cols = input<ColDef[]>([]);
    group = input.required<IGroupLevel>();
    appliedGroups = input<ColDef[]>([]);

    selectedColumnChange = output<ColDef>();
    closeOverlayEvent = output<void>();

    readonly selectedColumn = signal<ColDef | undefined>(undefined);

    private readonly iconSanitizer = inject(IconSanitizerService);

    readonly arrowIcon = this.iconSanitizer.getIcon('nextArrow');
    readonly checkMarkIcon = this.iconSanitizer.getIcon('checkMark');

    selectColumn(col: ColDef): void {
        this.selectedColumn.set(col);
    }

    applySelection(): void {
        const selected = this.selectedColumn();
        if (selected) {
            this.selectedColumnChange.emit(selected);
        }
    }

    closeOverlay(): void {
        this.closeOverlayEvent.emit();
    }

    isSelectedColumn(col: ColDef): boolean {
        const draft = this.selectedColumn();
        if (draft) {
            return draft.field === col.field;
        }

        const applied = this.appliedGroups()[this.group().level - 1];
        return applied?.field === col.field;
    }
}
